import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { IDemand } from '../../core/interfaces/demand.interface';
import { GetAllDemandAction } from './demand.actions';
import { demandData } from '../../data/demand.data';

export interface DemandStateModel {
  demand: IDemand[];
}

@State<DemandStateModel>({
  name: 'demand',
  defaults: {
    demand: [],
  },
})
@Injectable()
export class DemandState {
  @Selector() static GetAllData(state: DemandStateModel): IDemand[] {
    return state?.demand ? state?.demand : [];
  }

  demandArray: IDemand[] = [...demandData];

  constructor() {}

  @Action(GetAllDemandAction)
  GetAllDemandAction(ctx: StateContext<DemandStateModel>) {
    ctx.patchState({
      demand: this.demandArray,
    });
  }
}
